/**
 * 멤버 역할 표시용 한글 라벨.
 * 상태·비교·API에는 `mapMemberRoleToLabel`의 영문 값(Consortium Owner 등)을 그대로 쓰고,
 * 화면에만 이 함수로 변환한다.
 */
const ALLIANCE_MEMBER_ROLE_I18N_KEY = {
  'Consortium Owner': 'alli.status.roleOwner',
  'PI': 'alli.status.rolePi',
  'Observer': 'alli.status.roleObserver',
  'Researcher': 'alli.status.roleResearcher',
};

export function formatAllianceMemberRoleLabel(role, t) {
  if (role == null || role === '') return '';
  const i18nKey = ALLIANCE_MEMBER_ROLE_I18N_KEY[role];
  if (i18nKey && typeof t === 'function') return t(i18nKey);
  return String(role);
}

/** DB/API memberRoleCd(OWNER, PI…) → 멤버 관리 화면과 동일한 표시용 역할 키 */
export function memberRoleCdToFormatKey(memberRoleCd) {
  const role = String(memberRoleCd || '').toUpperCase();
  if (role === 'OWNER') return 'Consortium Owner';
  if (role === 'PI') return 'PI';
  if (role === 'OBSERVER') return 'Observer';
  if (role === 'RESEARCHER') return 'Researcher';
  return null;
}

/** memberRoleCd 한 방에 한글 라벨 (컨소시엄 멤버 카드와 동일) */
export function formatAllianceMemberRoleFromCode(memberRoleCd, t) {
  const key = memberRoleCdToFormatKey(memberRoleCd);
  if (key) return formatAllianceMemberRoleLabel(key, t);
  if (memberRoleCd == null || memberRoleCd === '') return '';
  return String(memberRoleCd);
}

/**
 * MemberAllTabCards / 컨소시엄 관리와 동일 색상의 뱃지 variant
 * @returns {'owner'|'pi'|'researcher'|'observer'}
 */
export function getAllianceMemberRoleBadgeVariant(memberRoleCd) {
  const key = memberRoleCdToFormatKey(memberRoleCd);
  if (key === 'Consortium Owner') return 'owner';
  if (key === 'PI') return 'pi';
  if (key === 'Researcher') return 'researcher';
  return 'observer';
}
